<template>
  <layout-basic>
    <div class="single-course-banner">
      <h1>FAQs</h1>
      <p>Frequently asked questions about our microlearning platform.</p>
    </div>
    <v-container class="margin-single-page">
      <v-row>
        <v-col>
            <v-expansion-panels
                accordion
                class="faq-expansion-panel"
                v-model="expandedPanel"
            >
                <v-expansion-panel
                class="faq-panel"
                v-for="(item, index) in faqItems"
                :key="index"
                >
                <v-expansion-panel-header>
                    <template #actions>
                        <i v-if="expandedPanel === index" class="fas fa-minus"></i>
                        <i v-else class="fas fa-plus"></i>
                    </template>
                    {{ item.question }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <p v-html="item.answer"></p>
                </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
    <section class="animate-cat-on-scroll">
        <v-row no-gutters>
            <v-col no-gutters>
            <!-- Shape Background -->
            <div class="demo-background">
                <img
                class="demo-background-image"
                :src="
                    getImageSource(
                    'improve-demo-section-background.png',
                    'homepage/demo'
                    )
                "
                />
                <img
                class="demo-background-cat"
                :src="
                    getImageSource(
                    'training-courses-for-smes-with-improve.png',
                    'homepage/demo'
                    )
                "
                />
                <div class="demo-content">
                <h2 style="color: #ffffff !important;">Request a Demo</h2>
                <p style="color: #E7F8FF !important;">
                    Book a free demonstration of IMPROVE today.
                </p>
                <a
                    href="/contact"
                    class="book-demo-btn"
                >
                    Let’s Go
                </a>
                </div>
            </div>
            </v-col>
        </v-row>
        </section>
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import { screensize } from '../../utils/screensize';

const getCurrentScreenSize = screensize();
const currentScreenSize = getCurrentScreenSize();

export default {
  name: 'FAQ',
  components: {
    LayoutBasic,
  },
  data() {
    return {
      expandedPanel: 0,
      screenSize: currentScreenSize,
      faqItems: [
      {
        question: "How do I contact IMPROVE?",
        answer: "Reach out anytime to <b>help@improve.online</b>.",
      },
      {
        question: "How long is the subscription?",
        answer: "We offer annual subscriptions or you can lock in the price with a 3-year subscription.",
      },
      {
        question: "Can I pay monthly?",
        answer: "No, the full cost of the subscription must be paid upfront before your account can be set to live.",
      },
      {
        question: "What is an LMS?",
        answer: "An LMS is a learning management system, it's a place to keep and organise all information about training in an organisation. For example, it allows people to take courses, track all of the access, and report on use.",
      },
      {
        question: "How do the HR integrations work?",
        answer: "Our current HR integrations are listed on our website and at a basic level when you add a user to your HR system it will also add that user to IMPROVE. See all HR integrations <b><a href='/hr-integrations'>here</a></b>.",
      },
      {
        question: "Can you integrate with any HR system?",
        answer: "If the HR system you use is not listed, get in touch and we can see if it's possible to integrate. See all HR integrations <b><a href='/hr-integrations'>here</a></b>.",
      },
      {
        question: "How does the pricing work?",
        answer: "The pricing is very transparent on the website and is by the number of users you need. There are currently 4 brackets: 0-20, 21-50, 51-100, 101-250, and we can support more than 250 users, so contact us for a price. See pricing page <b><a href='/pricing'>here</a></b> for more information.",
      },
      {
        question: "What is the maximum users I can have?",
        answer: "In theory, this is unlimited but the system is set to allow up to the maximum per the user brackets.",
      },
      {
        question: "Can I add more users?",
        answer: "At any point, you can prorate your subscription to add more users and go up to the next bracket.",
      },
      {
        question: "How do I pay?",
        answer: "We issue an invoice and you can pay electronically via BACS or by card.",
      },
      {
        question: "How long is the free trial?",
        answer: "Two weeks, talk to us if you would like to extend or show other team members, you can also book a demo <b><a href='/contact'>here</a></b>.",
      },
      {
        question: "How do I get a live account after a free trial?",
        answer: "Give us a shout at <b>help@improve.online</b> and we will issue an invoice. Once you pay the invoice, we will set your account status to live.",
      },
      {
        question: "Is there a reporting feature?",
        answer: "Yes, you can run reports within the system and download reports in PDF or XLS format.",
      },
      {
        question: "Can I give access to different teams?",
        answer: "We have a function called team manager which allows you to allocate users to team leaders so they can allocate courses and keep an eye on their team's progress.",
      },
      {
        question: "Can I partner with IMPROVE or resell IMPROVE?",
        answer: "Yes, get in touch with us anytime to discuss the various ways we partner with businesses.",
      },
      {
        question: "What is a Playlist?",
        answer: "A playlist is the place to categorise course content. For example, you could make an 'induction' playlist and add courses for new employees. You can also add extra content such as a map of the building or contact details.",
      },
      {
        question: "User count, is this active users only?",
        answer: "Users who you no longer need can be archived so they do not count in your user bracket.",
      },
      {
        question: "Does it work on a Mobile device?",
        answer: "Yes, IMPROVE is fully responsive and will adjust to the size of the screen/device you are using.",
      },
      {
        question: "How often can I access IMPROVE?",
        answer: "24/7 and as many times as you need.",
      },
      {
        question: "How many courses can each user take?",
        answer: "24/7 and as many times as you need.",
      },
      {
        question: "Will I get a certificate?",
        answer: "Yes, every single course, upon successful completion, will have a personalised certificate.",
      },
      {
        question: "Will I get any training on the platform?",
        answer: "We onboard all of our company admins via Teams.",
      },
      {
        question: "Is it easy to onboard staff?",
        answer: "Yes, and we are here to help.",
      },
      {
        question: "How many admins can I have?",
        answer: "You can have up to 10 admins on the platform.",
      },
      {
        question: "How do I cancel my subscription?",
        answer: "If you wish to cancel your contract with us, please get in touch at <b>help@improve.online</b> We will help you cancel the automatic renewal at least 30 days before it is due to renew.",
      },
      {
        question: "How do I contact you about an issue?",
        answer: "Simply email <b>support@improve.online</b> and one of our team will be on hand to help.",
      },
    ],
    };
  },
  metaInfo() {
    return {
      title: 'IMPROVE: FAQs about our microlearning platform for businesses.',
      meta: [
        // Meta Description
        { name: 'description', content: 'Our FAQs address a wide range of topics, including plans and payment, microlearning training courses, and how to become an IMPROVE partner.' },

        // Keywords
        { name: 'keywords', content: 'FAQs, microlearning platform, business training, training courses, IMPROVE partner' },

        // Open Graph / Facebook Tags
        { property: 'og:title', content: 'IMPROVE: FAQs about our microlearning platform for businesses.' },
        { property: 'og:description', content: 'Our FAQs address a wide range of topics, including plans and payment, microlearning training courses, and how to become an IMPROVE partner.' },
        {
          property: 'og:image',
          content: `https://www.improve.online/static/seo.png`,
        },
        {
          property: 'og:url',
          content: `https://www.improve.online/faq`,
        },

        // Twitter Card Tags
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: 'IMPROVE: FAQs about our microlearning platform for businesses.', },
        { name: 'twitter:description', content: 'Our FAQs address a wide range of topics, including plans and payment, microlearning training courses, and how to become an IMPROVE partner.' },
        {
          name: 'twitter:image',
          content: `https://www.improve.online/static/seo.png`,
        },
      ],
      link: [
        // Canonical URL
        {
          rel: 'canonical',
          href: `https://www.improve.online/faq`,
        },
      ],
    };
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
  },
  methods: {
    handleResize() {
      this.screenSize = getCurrentScreenSize();
    },
    getImageSource(imageName, filepath) {
      return `/static/${filepath}/${this.screenSize}/${imageName}`;
    },
    handleScroll() {
      const catElemet = this.$el.querySelector('.animate-cat-on-scroll');
      const catRect = catElemet.getBoundingClientRect();
      const catInViewport =
        catRect.top >= 0 &&
        catRect.left >= 0 &&
        catRect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        catRect.right <=
          (window.innerWidth || document.documentElement.clientWidth);

      if (catInViewport) {
        catElemet.classList.add('animate');
      }
    },
  },
  watch: {
  },
};
</script>

<style>
.single-course-banner {
  background-image: url(/static/single-page/banner.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 396px;
  width: 100%;
  margin-top: 167px;
}
.single-course-banner h1 {
  font-size: 50px;
  font-weight: 700;
  color: #122034;
  margin-bottom: 20px;
  max-width: 1420px;
  text-align: center;
}

.single-course-banner p {
  font-size: 16px;
  font-weight: 400;
  color: #122034;
  max-width: 918px;
  text-align: center;
}

i.fas.fa-plus {
  color: #122034 !important;
}

i.fas.fa-minus {
  color: #122034 !important;
}


.faq-panel.v-expansion-panel::before {
    box-shadow: none;
}

.faq-panel.v-expansion-panel {
    border-radius: 0 !important;
    border-bottom: 1px solid #D9D9D9 !important;
}
</style>
